module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAMAAAAW0r4eAAAAAXNSR0IArs4c6QAAAJNQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0TslXgAAADB0Uk5TAAECAwQFBgcKGh0hIiUnLDM2OjxARkxNXV9mZ36BhIi7vMnK1drb3ODo6u7x/P3+IIcPdQAAAHpJREFUKM/Fy9saQkAYheGf0U6hUmiLmkpNzLr/q3NqjQuwDr9nvSLLJFoIzTv9v2du3rWDKfgWPYC24F9cWZgLt3WFkY0ntbOR/R35t6lhy4DSVqO7+cNy0MBnR+UNmFSxsk3qqiZXE6n9y1X+3TpKJNfPTHGahysuPU3uFojZjvD2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money_arrowr.png
// module id = Laka
// module chunks = 0